import styled from "styled-components"

import { colors, spacing } from "@izettle/otto"

export type DividerProps = {
  marginTop?: string
  marginBottom?: string
}

export const Divider = styled.div<DividerProps>`
  height: 1px;
  /* stylelint-disable-next-line */
  background-color: ${colors.border.divider};
  width: 100%;
  margin-top: ${(p) => p.marginTop ?? spacing.medium};
  margin-bottom: ${(p) => p.marginBottom ?? spacing.medium};
`
